import { Box, Typography } from "@mui/material";
import React from "react";
import ControlDataStatusIndicator from "./ControlDataStatusIndicator";

export type DashboardCardProps = {
    title: string;
    value: string;
    sufixx: string;
    icon: React.ReactNode;
    backgroudIconColor: string;
    isLoading?: boolean;
}

export default function DashboardCard(props: DashboardCardProps) {
    const { icon, sufixx, title, value, backgroudIconColor, isLoading } = props

    return (
        <Box sx={{ display: "flex", flexDirection: "row", alignItems: "center", borderRadius: "8px", border: "1px solid #8F969E", height: "auto", justifyContent: "flex-start", padding: "12px" }}>
            <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", marginRight: "24px", marginLeft: "8px", backgroundColor: backgroudIconColor, width: "40px", height: "40px", borderRadius: "8px" }}>{icon}</Box>
            <Box>
                <Box sx={{ marginRight: "18px", display: "flex", alignItems: "center" }}>
                    <Typography sx={{ fontWeight: "400", fontSize: "14px", textAlign: "start" }}>{title}</Typography>
                    {typeof isLoading === "boolean" && <ControlDataStatusIndicator isLoading={isLoading} />}
                </Box>
                <Box sx={{ display: "flex", flexDirection: "row", alignItems: "flex-end", gap: "8px", marginTop: "4px" }}>
                    <Typography sx={{ fontWeight: "900", fontSize: "18px" }}>{value}</Typography>
                    <Typography sx={{ color: "#8F969E", fontWeight: "500", fontSize: "12px" }}>{sufixx}</Typography>
                </Box>
            </Box>
        </Box>
    )
}